import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function HSCallback() {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const code = searchParams.get('code');
        if (!code) return;

        if (window.opener) {
            window.opener.postMessage(
                { type: 'HUBSPOT_OAUTH_CODE', code },
                window.location.origin
            );
        }
    }, [searchParams]);

    return <>Connecting to HubSpot, please wait...</>;
}
